/**
 * Logout Confirmation Modal
 * Modal to confirm user logout action using shadcn Dialog
 */

import { LogOut } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useTranslation } from "@/language"

interface LogoutConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export function LogoutConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
}: LogoutConfirmationModalProps) {
  const { t } = useTranslation("common")

  return (
    <Dialog open={isOpen} onOpenChange={(open: boolean) => !open && onClose()}>
      <DialogContent showCloseButton={false} className="w-md">
        {/* Icon Section */}
        <div className="flex justify-center">
          <div className="w-12 h-12 rounded-full flex items-center justify-center bg-red/10">
            <LogOut size={24} className="text-red" />
          </div>
        </div>

        <DialogHeader className="text-center">
          <DialogTitle className="text-charcoal text-2xl font-semibold text-center">
            {t("logoutModal.title")}
          </DialogTitle>
          <DialogDescription className="text-stone text-center text-sm leading-relaxed">
            {t("logoutModal.description")}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex-row gap-3 sm:flex-row">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 rounded-lg border-gray text-charcoal"
          >
            {t("logoutModal.stay")}
          </Button>
          <Button variant="destructive" onClick={onConfirm} className="flex-1 rounded-lg bg-red">
            {t("logoutModal.logOut")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
